export default (theme) => ({
    '& .w5-tooltip': {
        display: 'none',
        maxWidth: '150px',
        backgroundColor: theme.colors.grey[700],
        color: theme.colors.primary.white,
        borderRadius: '3px',
        padding: '5px',
        zIndex: 10000,
        pointerEvents: 'none',
        ...theme.typography.smallText,
        '& .w5-tooltip-arrow': {
            position: 'absolute',
            width: '6px',
            height: '6px',
            pointerEvents: 'none',
            '&:before': {
                content: '""',
                position: 'absolute',
                width: '6px',
                height: '6px',
                borderRadius: '1px',
                transform: 'rotate(45deg)',
                background: theme.colors.grey[700],
            },
        },
        '&[data-popper-placement^=top] > .w5-tooltip-arrow': {
            bottom: '-3px',
        },
        '&[data-popper-placement=top] > .w5-tooltip-arrow': {
            left: '50%',
            marginLeft: '-3px',
        },
        '&[data-popper-placement=top-start] > .w5-tooltip-arrow': {
            left: '8px',
        },
        '&[data-popper-placement=top-end] > .w5-tooltip-arrow': {
            right: '8px',
        },
        '&[data-popper-placement^=bottom] > .w5-tooltip-arrow': {
            top: '-3px',
        },
        '&[data-popper-placement=bottom] > .w5-tooltip-arrow': {
            left: '50%',
            marginLeft: '-3px',
        },
        '&[data-popper-placement=bottom-start] > .w5-tooltip-arrow': {
            left: '8px',
        },
        '&[data-popper-placement=bottom-end] > .w5-tooltip-arrow': {
            right: '8px',
        },
        '&[data-popper-placement^=left] > .w5-tooltip-arrow': {
            right: '-3px',
        },
        '&[data-popper-placement=left] > .w5-tooltip-arrow': {
            top: '50%',
            marginTop: '-3px',
        },
        '&[data-popper-placement^=right] > .w5-tooltip-arrow': {
            left: '-3px',
        },
        '&[data-popper-placement=right] > .w5-tooltip-arrow': {
            top: '50%',
            marginTop: '-3px',
        },
    },
});
